<!-- Entête -->
<h1 mat-dialog-title>
    <span [translate]="'od.voyage.voyage'"></span>
    <span class="actions" [mat-dialog-close]>
            <span><i class="zmdi zmdi-close"></i></span>
        </span>
</h1>

<!-- Contenu -->
<div mat-dialog-content>
    <div class="listview">
        <div class="listview-body">
            <div class="listview-item" *ngFor="let niveauNature of listeSbtParNature | async | triListeSbt" (click)="selectionne(niveauNature)">
                <ng-container *ngTemplateOutlet="optionTravel; context:{
                        portee:niveauNature.nature,
                        isOnline:niveauNature.getSbtPrincipal().typeAiguillage === TypeAiguillage.ONLINE,
                        isOffline:niveauNature.getSbtPrincipal().typeAiguillage === TypeAiguillage.OFFLINE || niveauNature.listeSbt.length > 1,
                        isInterne:niveauNature.getSbtPrincipal().typeAiguillage === TypeAiguillage.INTERNE}">
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #optionTravel let-portee="portee" let-isOnline="isOnline" let-isOffline="isOffline" let-isInterne="isInterne">
    <div class="lvi-content clickable">
        <div class="avatar" *ngIf="TypeNature.icone(portee) as iconTypeNature">
            <!-- Icône de l'option -->
            <span [class]="iconTypeNature.cssClass">{{ iconTypeNature.icon }}</span>
        </div>
        <div class="lvi-body">
            <div class="title">
                <a><strong>{{ TypeNature.traduction(portee) | translate }}</strong></a>
            </div>
            <!-- Bulles -->
            <ul class="lvi-attrs">
                <li><strong translate>od.voyage.travel.reservation</strong>{{ (isOnline && isOffline ? 'od.voyage.travel.directOuAgence' : isOnline ? 'od.voyage.travel.direct' : isInterne ? 'od.voyage.travel.interne' : 'od.voyage.travel.agence') | translate }}</li>
                <!-- Tag CO2e générique -->
                <li (click)="$event.stopPropagation();openPopupRse();" *ngIf="odRseService.odRseValueByNature.value?.get(portee) as rseValue" [nioTooltip]="'rse.asterisque' | translate" class="rse-tag">
                    <span class="material-symbols-rounded">eco</span>
                    <span class="mini-icon" [class]="TypeNature.icone(portee).cssClass">{{ TypeNature.icone(portee).icon }}</span>
                    <strong></strong>
                    {{(rseValue | number:"1.2-3") + ('rse.kgCO2' | translate)}}*
                </li>
                <!-- Tag CO2e pour l'avion en cas d'avion/train -->
                <li (click)="$event.stopPropagation();openPopupRse();" *ngIf="portee == TypeNature.AVION_TRAIN && odRseService.odRseValueByNature.value?.get(TypeNature.AVION) as rseValue" [nioTooltip]="'rse.asterisque' | translate" class="rse-tag">
                    <span class="material-symbols-rounded">eco</span>
                    <span class="mini-icon" [class]="TypeNature.icone(TypeNature.AVION).cssClass">{{ TypeNature.icone(TypeNature.AVION).icon }}</span>
                    <strong></strong>
                    {{(rseValue | number:"1.2-3") + ('rse.kgCO2' | translate)}}*
                </li>
                <!-- Tag CO2e pour le train en cas d'avion/train -->
                <li (click)="$event.stopPropagation();openPopupRse();" *ngIf="portee == TypeNature.AVION_TRAIN && odRseService.odRseValueByNature.value?.get(TypeNature.TRAIN) as rseValue" [nioTooltip]="'rse.asterisque' | translate" class="rse-tag">
                    <span class="material-symbols-rounded">eco</span>
                    <span class="mini-icon" [class]="TypeNature.icone(TypeNature.TRAIN).cssClass">{{ TypeNature.icone(TypeNature.TRAIN).icon }}</span>
                    <strong></strong>
                    {{(rseValue | number:"1.2-3") + ('rse.kgCO2' | translate)}}*
                </li>
            </ul>
        </div>
    </div>
</ng-template>